export { MdShare as IconShare } from "react-icons/md";
